import { isSupportedLanguage } from './locale.js';
export function getBrowserLocalStorage() {
    try {
        if (typeof window === 'undefined')
            return null;
        return window.localStorage;
    }
    catch {
        return null;
    }
}
function readSchemaVersion(storage, key) {
    const raw = storage.getItem(key);
    const parsed = Number.parseInt(raw || '', 10);
    return Number.isFinite(parsed) && parsed > 0 ? parsed : 0;
}
export function runStorageMigrations(storage, options) {
    if (!storage)
        return;
    const currentVersion = readSchemaVersion(storage, options.schemaVersionKey);
    const nextMigrations = [...options.migrations]
        .filter((migration) => migration.version > currentVersion && migration.version <= options.targetVersion)
        .sort((left, right) => left.version - right.version);
    for (const migration of nextMigrations) {
        migration.migrate(storage);
    }
    storage.setItem(options.schemaVersionKey, String(options.targetVersion));
}
export function removeStorageKeys(storage, keys) {
    if (!storage)
        return;
    for (const key of keys) {
        storage.removeItem(key);
    }
}
export function readLocalePreference(storage, keys) {
    if (!storage) {
        return { mode: 'auto', manualLanguage: null };
    }
    const mode = storage.getItem(keys.modeKey) === 'manual' ? 'manual' : 'auto';
    const storedLanguage = storage.getItem(keys.manualLanguageKey);
    const manualLanguage = isSupportedLanguage(storedLanguage) ? storedLanguage : null;
    if (mode === 'manual' && manualLanguage) {
        return { mode, manualLanguage };
    }
    return { mode: 'auto', manualLanguage: null };
}
export function ensureLocaleMode(storage, keys, mode = 'auto') {
    if (!storage)
        return;
    const existing = storage.getItem(keys.modeKey);
    if (existing === 'auto' || existing === 'manual')
        return;
    storage.setItem(keys.modeKey, mode);
}
export function setManualLocalePreference(storage, keys, language) {
    if (!storage)
        return;
    storage.setItem(keys.modeKey, 'manual');
    storage.setItem(keys.manualLanguageKey, language);
}
export function setAutoLocalePreference(storage, keys) {
    if (!storage)
        return;
    storage.setItem(keys.modeKey, 'auto');
    storage.removeItem(keys.manualLanguageKey);
}
//# sourceMappingURL=storage.js.map